import { render, staticRenderFns } from "./marketing01.vue?vue&type=template&id=2bb3a318&scoped=true&"
import script from "./marketing01.vue?vue&type=script&lang=js&"
export * from "./marketing01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb3a318",
  null
  
)

export default component.exports